<template>
    <div :class="className">
        <jet-section-title>
            <template #title><slot name="title"></slot></template>
            <template #description><slot name="description"></slot></template>
        </jet-section-title>

        <form @submit.prevent="$emit('submitted')">
            <slot name="form"></slot>
            <div v-if="hasActions">
                <slot name="actions"></slot>
            </div>
        </form>
    </div>
</template>

<script>
    import JetSectionTitle from './SectionTitle'

    export default {
        components: {
            JetSectionTitle,
        },
        props: ['className'],

        computed: {
            hasActions() {
                return !! this.$slots.actions
            }
        }
    }
</script>
